import React, { useEffect, useState } from "react";
import { Layout, Tabs, Modal, Typography } from "antd";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import {
  loadRecord,
  setActiveGeo,
  reset,
  commitChanges,
} from "./employeeDetailsSlice";
import Activities from "../activities";
import { getFullName } from "../../components/util/helpers";
import { useSelector, useDispatch } from "react-redux";
import Foreign from "./forms/Foreign";
import Form101 from "./forms/Form101";
import Informatiom from "./forms/Informatiom";
import EmployeeScheduling from "../employeeScheduling";
import WorkDiaries from "../employeeWorkDiaries";
import Absences from "../employeeAbsences";
import EmployeeHouseVisits from "../employeeHouseVisits";
import ControllersVisits from "../employeeHouseVisits/ControllersVisits";
import EmployeePersonalFile from "../employeePersonalFile";
import EmployeeDocuments from "../employeeDocuments";
import { FormattedMessage } from "react-intl";
import { unsavedChangesConfirmMessage } from "../../components/forms/formsFeedback";
import StaffInformation from "./staffDetails/Information";
import NavigationPrompt from "react-router-navigation-prompt";
import { usePermission } from "../../hooks/accessControl";
import EmployeeLogs from "../logs/EmployeeLogs";
const { Text } = Typography;

const Employee = (props) => {
  const [activeTab, setActiveTab] = useState("information");
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [modal, contextHolder] = Modal.useModal();
  const intl = useIntl();
  const hasChanges = useSelector(
    (state) => state.employeeDetails.changedItems.changed.length > 0
  );
  const changedValues = useSelector(
    (state) => state.employeeDetails.changedItems.values
  );
  const changedItems = useSelector(
    (state) => state.employeeDetails.changedItems.changed
  );
  const organizationDetails = useSelector(
    (state) => state.organization.details
  );
  let history = useHistory();
  let location = useLocation();
  let { branchId, id } = useParams();
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const saveLoading = useSelector(
    (state) => state.pendingActions["employeeDetails/update"]
  );
  const getLoading = useSelector(
    (state) => state.pendingActions["employeeDetails/loadEmployee"]
  );
  const dispatch = useDispatch();
  const loadEmployee = async () => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      id: id,
      branchId: branchId,
      admin: isAdmin,
    };
    const record = await dispatch(loadRecord(params));
    if (record?.payload?.geo?.latitude) {
      dispatch(setActiveGeo({ record: record.payload.geo }));
    }
  };

  useEffect(() => {
    if (
      location.state &&
      location.state.activeTab &&
      location.state.activeTab === "scheduling"
    ) {
      onChange("employee_scheduling");
    }
  }, [location.state]);

  useEffect(() => {
    if (
      activeEmployee.staff_member &&
      !activeEmployee.care_giver &&
      !history.location.state
    ) {
      history.replace({ ...history.location, state: { staff: true } });
    }
    if (
      !activeEmployee.staff_member &&
      activeEmployee.care_giver &&
      history.location.state &&
      history.location.state.staff
    ) {
      history.replace({ ...history.location, state: null });
    }
  }, [
    activeEmployee.staff_member,
    activeEmployee.care_giver,
    history.location.state,
  ]);

  useEffect(() => {
    loadEmployee();
    return function cleanup() {
      dispatch(reset());
    };
  }, [dispatch]);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    //pop error notification
  };

  const onDecline = () => {
    history.goBack();
  };
  const components =
    (location.state && location.state.staff && !activeEmployee.id) ||
    (location.state && location.state.staff && activeEmployee.staff_member) ||
    (activeEmployee.staff_member && !activeEmployee.care_giver)
      ? [
          {
            key: "information",
            titleId: "app.employees.information",
            comp: (
              <div>
                <StaffInformation
                  onSubmit={() => dispatch(commitChanges())}
                  onFinishFailed={onFinishFailed}
                  onDecline={onDecline}
                  saveLoading={saveLoading}
                  addImage={setAvatarUrl}
                  avatarUrl={avatarUrl}
                  uri={activeEmployee.avatar_url}
                  activeEmployee={activeEmployee}
                  loadEmployee={loadEmployee}
                />
              </div>
            ),
          },
        ]
      : [
          {
            key: "information",
            titleId: "app.employees.information",
            comp: (
              <div>
                <Informatiom
                  onSubmit={() => dispatch(commitChanges())}
                  onFinishFailed={onFinishFailed}
                  onDecline={onDecline}
                  saveLoading={saveLoading}
                  activeEmployee={activeEmployee}
                  loadEmployee={loadEmployee}
                />
              </div>
            ),
          },
          {
            key: "absences",
            titleId: "app.employees.absences",
            disabled:
              !activeEmployee?.local_id_number &&
              activeEmployee?.employee_type_id !== 2,
            comp: <Absences />,
          },
          {
            key: "documentation",
            titleId: "app.employees.personal_file",
            comp: <EmployeePersonalFile />,
          },

          {
            key: "form101",
            titleId: "app.employees.form101",
            comp: (
              <div>
                <Form101
                  onSubmit={() => dispatch(commitChanges())}
                  onFinishFailed={onFinishFailed}
                  onDecline={onDecline}
                  saveLoading={saveLoading}
                  activeEmployee={activeEmployee}
                />
              </div>
            ),
          },

          {
            key: "foreignWorkers",
            titleId: "app.employees.foreignWorkers",
            hide: activeEmployee.employee_type_id !== 2,
            comp: (
              <div>
                <Foreign
                  onSubmit={() => dispatch(commitChanges())}
                  onFinishFailed={onFinishFailed}
                  onDecline={onDecline}
                  saveLoading={saveLoading}
                  activeEmployee={activeEmployee}
                  changedValues={changedValues}
                  changedItems={changedItems}
                />
              </div>
            ),
          },
          {
            key: "employee_scheduling",
            titleId: "app.employees.employee_scheduling",
            disabled:
              !activeEmployee?.local_id_number &&
              activeEmployee?.employee_type_id !== 2,
            comp: (
              <div style={{ display: "flex", height: "100%" }}>
                <EmployeeScheduling activeTab={activeTab} />
              </div>
            ),
          },
          {
            key: "employee_work_diaries",
            titleId: "app.employees.employee_work_diaries",
            disabled:
              !activeEmployee?.local_id_number &&
              activeEmployee?.employee_type_id !== 2,
            comp: <WorkDiaries activeTab={activeTab} />,
          },
        ];

  if (activeEmployee.professional_role_id) {
    components.push({
      key: "house_visits",
      titleId: "app.patients.house_visits",
      comp: (
        <div style={{ display: "flex", height: "100%" }}>
          <EmployeeHouseVisits activeTab={activeTab} />
        </div>
      ),
    });
  }

  if (
    activeEmployee.professional_role_id &&
    activeEmployee.professional_role_id !== 3
  ) {
    components.push({
      key: "controllers_visits",
      titleId: "app.patients.controllers_visits",
      comp: <ControllersVisits activeTab={activeTab} />,
    });
  }

  const hasAssetsPermission = usePermission(branchId, "assets", "viewer");
  if (hasAssetsPermission) {
    components.push({
      key: "documents",
      titleId: "app.employees.documents",
      comp: <EmployeeDocuments />,
    });
  }

  const allowedFeatures =
    organizationDetails.features &&
    organizationDetails.features.map((i) => i.name);
  const crmIsAllowed = allowedFeatures?.includes("crm");
  const hasCrmViewerPermission = usePermission(branchId, "crm", "viewer");
  if (crmIsAllowed && hasCrmViewerPermission) {
    components.splice(5, 0, {
      key: "activities",
      titleId: "app.patients.activities",
      comp: (
        <Activities
          entity={"employees"}
          entityId={activeEmployee.id}
          branchId={branchId || activeEmployee?.active_branches?.[0]?.id}
          branches={activeEmployee?.active_branches?.map((i) => i.id)}
          entityName={getFullName(
            activeEmployee.surename,
            activeEmployee.first_name
          )}
          reportId={
            activeEmployee.local_id_number
              ? `תעודת זהות - ${activeEmployee.local_id_number}`
              : ""
          }
          hasEmail={
            activeEmployee?.contact_info?.email &&
            activeEmployee?.agree_to_receive_email === true
          }
        />
      ),
    });
  }

  components.push({
    key: "logs",
    titleId: "app.employees.logs",
    comp: <EmployeeLogs activeTab={activeTab} />,
  });

  const navigateAndLoad = (key, params) => {
    setActiveTab(key);
    const keys = [
      "information",
      "absences",
      "documentation",
      "form101",
      "foreignWorkers",
    ];
    if (keys.includes(key)) {
      dispatch(loadRecord(params));
    }
  };

  const onChange = async (key) => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      id: id,
      branchId: branchId,
      admin: isAdmin,
    };

    if (hasChanges) {
      await unsavedChangesConfirmMessage({
        intl,
        onOk: () => {
          navigateAndLoad(key, params);
        },
        onCancel: () => {},
        modal,
      });
      return;
    }
    navigateAndLoad(key, params);
  };

  if (getLoading && !location.state === undefined) return null;

  return (
    <Layout style={{ zIndex: 5, background: "transparent" }}>
      <NavigationPrompt when={hasChanges}>
        {({ onConfirm, onCancel }) => {
          return (
            <Modal
              title={intl.formatMessage({
                id: "app.forms.unSavedChangesTitle",
              })}
              open={true}
              onOk={() => {
                onConfirm();
              }}
              onCancel={onCancel}
              okText={intl.formatMessage({
                id: "app.forms.unSavedChangesOkText",
              })}
              cancelText={intl.formatMessage({
                id: "app.forms.unSavedChangesCancelText",
              })}
            >
              <Text>
                {intl.formatMessage({
                  id: "app.forms.unSavedChangesContent",
                })}
              </Text>
            </Modal>
          );
        }}
      </NavigationPrompt>
      {contextHolder}
      <Tabs
        defaultActiveKey="information"
        activeKey={activeTab}
        onChange={onChange}
        animated={false}
        items={components.map((option) =>
          !option.hide
            ? {
                label: <FormattedMessage id={option.titleId} />,
                key: option.key,
                disabled: option.disabled,
                children: <>{option.comp}</>,
              }
            : null
        )}
      />
    </Layout>
  );
};

export default Employee;
